import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * Guards portal routes:
 *   - no token → /portal/{slug}/login
 *   - logged in but role !== client → /login (admin's home)
 *   - must_change_password → force /portal/{slug}/change-password
 */
export default function PortalProtectedRoute({ slug, children }) {
  const token = localStorage.getItem("ra_token");
  const user = JSON.parse(localStorage.getItem("ra_user") || "null");
  const location = useLocation();

  if (!token || !user) {
    return <Navigate to={`/portal/${slug}/login`} replace />;
  }
  if (user.role !== "client") {
    // Admin landed in portal somehow — kick to admin home
    return <Navigate to="/" replace />;
  }
  if (user.must_change_password && !location.pathname.endsWith("/change-password")) {
    return <Navigate to={`/portal/${slug}/change-password`} replace />;
  }
  return children;
}
